// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"cd6fda52","43":"3727b762","122":"d64de351","137":"0d8cc8b9","382":"960af3dd","394":"982e57e9","782":"22f3db9b","892":"72b8f9bc","950":"37a6255e"}[chunkId] + ".chunk.js";
};